'use strict';
import * as $j_app$002etulz$002etuplez$002e$002dComposition from "./app.tulz.tuplez.-Composition.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66() {
}
export { $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 as $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 };
$p = $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66.prototype = new $j_app$002etulz$002etuplez$002e$002dComposition.$h_Lapp_tulz_tuplez_Composition();
$p.constructor = $c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66;
/** @constructor */
function $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66() {
}
export { $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 as $h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 };
$h_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66.prototype = $p;
$p.aex = (function(c) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), c, (void 0));
});
$p.IN = (function(a, b) {
  return a;
});
var $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66, "app.tulz.tuplez.Composition_Pri10$$anon$66", ({
  Is: 1,
  eE: 1
}));
export { $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 as $d_Lapp_tulz_tuplez_Composition\uff3fPri10$$anon$66 };
//# sourceMappingURL=app.tulz.tuplez.-Composition_-Pri10$$anon$66.js.map
